import { User } from "@auth0/auth0-react";
import create from "zustand";
import { UserResourceType } from "~/hooks/query";

interface AuthState {
  authToken: string | null;
  authError: string | null;
  initialized: boolean;
  superAdmin: boolean;
  userInfo: (User & UserResourceType) | Record<string, never>;
  setAuthToken: (authToken: string) => void;
  setAuthError: (authError: string) => void;
  setSuperAdmin: (superAdmin: boolean) => void;
  setTelegramId: (telegramId: string) => void;
  login: (userInfo?: User & UserResourceType) => void;
  logout: () => void;
  authenticated: () => boolean;
}

const authStore = create<AuthState>()((set, get) => ({
  authToken: null,
  authError: null,
  initialized: false,
  superAdmin: false,
  userInfo: {},
  setAuthToken: (authToken) => set(() => ({ authToken })),
  setAuthError: (authError) => set(() => ({ authError })),
  setSuperAdmin: (superAdmin) => set(() => ({ superAdmin })),
  setTelegramId: (telegramId) =>
    set(() => ({ userInfo: { ...get().userInfo, telegram_id: telegramId } as User & UserResourceType })),
  login: (userInfo) => set(() => ({ userInfo, initialized: true, authError: null })),
  logout: () => set(() => ({ authToken: null, userInfo: {} })),
  authenticated: () => !!get().authToken,
}));

export default authStore;
